export default __webpack_public_path__ + "images/68fdee7ec9f05fb2b4e400cf1b6b6c74-obstacles_small.webp";